export const AvatarNavbarSciFiIcon = ({
  className = '',
}: {
  className?: string
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1460_91934)">
        <path
          d="M11.88 1.87V6.87V8.54L14.38 6.87H18.54C19 6.87 19.38 6.5 19.38 6.04V1.87C19.38 1.41 19 1.04 18.54 1.04H12.71C12.25 1.04 11.88 1.41 11.88 1.87Z"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M8.54 9.38H2.71C1.79 9.38 1.04 10.12 1.04 11.04V17.71C1.04 18.63 1.79 19.38 2.71 19.38H14.37C15.3 19.38 16.04 18.63 16.04 17.71V11.04"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M5.21 6.04V4.38"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M5.21 4.38C5.67 4.38 6.04 4 6.04 3.54C6.04 3.08 5.67 2.71 5.21 2.71C4.75 2.71 4.38 3.08 4.38 3.54C4.38 4 4.75 4.38 5.21 4.38Z"
          fill="#737373"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M5.63 14.38C6.32 14.38 6.88 13.82 6.88 13.13C6.88 12.43 6.32 11.88 5.63 11.88C4.93 11.88 4.38 12.43 4.38 13.13C4.38 13.82 4.93 14.38 5.63 14.38Z"
          fill="#737373"
        />
        <path
          d="M11.46 14.38C12.15 14.38 12.71 13.82 12.71 13.13C12.71 12.43 12.15 11.88 11.46 11.88C10.77 11.88 10.21 12.43 10.21 13.13C10.21 13.82 10.77 14.38 11.46 14.38Z"
          fill="#737373"
        />
      </g>
      <defs>
        <clipPath id="clip0_1460_91934">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
